import { useEffect, useState, useRef } from 'react';

const useMobile = (breakpoint: number) => {
  const minWidth = useRef(breakpoint);
  const [isMobile, setIsMobile] = useState(window.innerWidth < minWidth.current);

  useEffect(() => {
    const checkWindowWidth = () => {
      if (window.innerWidth < minWidth.current) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };
    window.addEventListener('resize', checkWindowWidth);

    return () => {
      window.removeEventListener('resize', checkWindowWidth);
    };
  }, []);

  return { isMobile };
};

export { useMobile };
